var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.userPickl && Object.keys(_vm.userPickl).length > 0
      ? _c(
          "h2",
          { staticStyle: { display: "block", "text-align": "center" } },
          [_vm._v("Task Overview")]
        )
      : _vm._e(),
    _vm.userPickl && Object.keys(_vm.userPickl).length > 0
      ? _c(
          "div",
          {
            staticClass: "pickl-details green-border-box",
            staticStyle: { margin: "2%", padding: "1%" }
          },
          [
            _c("UserPicklDetailsPopupOverview", {
              attrs: {
                brand: _vm.brand,
                userPickl: _vm.userPickl,
                isBrand: _vm.isBrand
              }
            })
          ],
          1
        )
      : _vm._e(),
    !_vm.loading && Object.keys(_vm.userPickl).length == 0
      ? _c("div", { staticClass: "outer-box vertical-center-transform" }, [
          _c("h2", { staticStyle: { padding: "20rem" } }, [
            _vm._v("Task Not Found!")
          ])
        ])
      : _vm._e(),
    _vm.loading
      ? _c("div", { staticClass: "outer-box vertical-center-transform" }, [
          _c("h2", { staticStyle: { padding: "20rem" } }, [
            _vm._v("Loading Task Details........")
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }